import React, { useState, useEffect } from "react";
import "./LiveIcon.scss";
import { useHistory } from "react-router-dom";
import { checkChannelLive } from "../../../API/youtube";

export default function LiveIcon() {
  const [isLive, setIsLive] = useState(false);
  useEffect(() => {
    checkChannelLive()
      .then(({ isLive: live }) => {
        setIsLive(live);
      })
      .catch((err) =>
        console.error("Failed to check YouTube live status:", err)
      );
  }, []);
  const history = useHistory();

  return (
    <div
      onClick={() => {
        history.push("/live-vod");
      }}
      className={`outer-circle-2 ${!isLive && "no-live"}`}
    >
      <div className={`outer-circle-1 ${!isLive && "no-live"}`}>
        <div className={`inner-circle ${!isLive && "no-live"}`}>
          <div className="live-text">LIVE</div>
        </div>
      </div>
    </div>
  );
}
